import { render, staticRenderFns } from "./ImpostazioniEvento.vue?vue&type=template&id=773e5b94&"
import script from "./ImpostazioniEvento.vue?vue&type=script&lang=js&"
export * from "./ImpostazioniEvento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports